module.exports = __webpack_public_path__ + "img/code.9b76d61f.png";